/**
 * A task description as a reader wrote it. Descriptions are stored three ways: draft-js raw JSON
 * (`{"blocks":[...]}`, the current editor), legacy HTML (`<div>`/`<p>`), and plain text. Rendering
 * the first raw would show the stored JSON. `Util.ConvertDraftJsToPlainText` does the same for the
 * legacy CSV export but would pull `shared/util/util.js` and draft-js into the report bundle; this is
 * the same three rules with no dependency, and `richTextScript` (exportCellScripts) mirrors it for export.
 */
export function richTextToPlain(value: string): string {
	const trimmed = value.trim();
	if (trimmed.startsWith('{')) {
		try {
			const parsed = JSON.parse(trimmed) as {blocks?: unknown};
			if (Array.isArray(parsed.blocks)) {
				return parsed.blocks
					.map(block =>
						block && typeof (block as {text?: unknown}).text === 'string' ? (block as {text: string}).text : ''
					)
					.join('\n')
					.trim();
			}
		} catch {
			// Not JSON after all: plain text that happens to start with a brace.
		}
		return value;
	}
	if (trimmed.startsWith('<')) {
		const doc = new DOMParser().parseFromString(
			trimmed.replace(/<br\s*\/?>/gi, '\n').replace(/<\/(p|div|li|h\d)>/gi, '$&\n'),
			'text/html'
		);
		return (doc.body.textContent ?? '').replace(/\n{2,}/g, '\n').trim();
	}
	return value;
}
